<template>
  <div
    class="relative max-w-screen-4xl mx-auto h-screen flex flex-col lg:flex-row items-center justify-between px-6 lg:px-32"
  >
    <div class="absolute inset-0 overflow-hidden">
      <video
        v-show="currentVideo === 1"
        autoplay
        muted
        loop
        playsinline
        class="w-full h-full object-cover"
      >
        <source src="../assets/videos/DONE.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div class="absolute inset-0 bg-black opacity-50"></div>
    </div>
  </div>

  <!-- Welcome to the success story of Mshel Group -->
  <div class="bg-white py-10">
    <div class="md:px-12 max-w-screen-xl mx-auto py-4 mb-10">
      <h1 class="text-center text-base font-bold mt-4 px-2 lg:px-1">
        Welcome to the Success Story <br />
        of Mshel Group
      </h1>
      <p class="text-center text-sm mt-4 px-2 lg:px-1">
        Let's uncover the diverse and innovative subsidiaries that make up The
        <br />
        Mshel Group, each committed to excellence across real estate,
        hospitality, construction and social impact.
      </p>
    </div>
  </div>

  <!-- Mshel Different Subsidiaries -->
   <subsidiariesSection />
   <groupObjectives />
   <whoWeAre />
   <whatWeDo />
   <barkasQuote />
</template>

<script>
import subsidiariesSection from "../components/subsidiariesSection.vue";
import whoWeAre from "../components/whoWeAre.vue";
import barkasQuote from "../components/barkasQuote.vue";
import whatWeDo from "../components/whatWeDo.vue";
import groupObjectives from "../components/groupObjectives.vue";

export default {
  components: {
    subsidiariesSection,
    whoWeAre,
    barkasQuote,
    whatWeDo,
    groupObjectives
  },
  data() {
    return {
      currentIndex: 0,
      currentVideo: 1,
    };
  },
  mounted() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("fade-in");
          } else {
            entry.target.classList.remove("fade-in");
          }
        });
      },
      {
        threshold: 0.2, // Adjust for smoother animation trigger
      }
    );

    document
      .querySelectorAll(".strategic-card")
      .forEach((card) => observer.observe(card));
  },
};
</script>

<style scoped>
svg path {
  fill: #ffffff !important;
  stroke: none !important;
  box-shadow: none !important;
}

svg {
  overflow: hidden !important;
}

.absolute.bottom-0 {
  line-height: 0 !important;
  padding-bottom: 0 !important;
  margin-bottom: -2px;
}

.overflow-hidden {
  overflow: hidden !important;
}

.strategic-style {
  font-family: "Caveat";
}

.strategic-card {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 1s ease-out, transform 1s ease-out;
  will-change: opacity, transform;
}

.strategic-card.fade-in {
  opacity: 1;
  transform: translateY(0);
}

.strategic-card:hover {
  transform: scale(1.03);
  /* box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2); */
  transition: transform 0.4s ease-out, box-shadow 0.4s ease-out;
  /* background-color: inherit !important; */
  box-shadow: none !important;
}
</style>
